import { es } from './es';
import { en } from './en';
export const CATALOGS = { es, en };
//# sourceMappingURL=index.js.map